import type { CurrencyDTO } from '@serviquim/contracts';
import { useT } from '../i18n';
import { formatMoney } from '../lib/money';
import { Card } from './ui/Card';

export function TripStatsCard({
  teto,
  totalGasto,
  sobra,
  moeda,
}: {
  teto: string;
  totalGasto: string;
  sobra: string;
  moeda?: CurrencyDTO;
}) {
  const { t } = useT();
  return (
    <Card className="grid grid-cols-3 gap-2 text-center">
      <div>
        <p className="text-xs text-ink-muted">{t('trips.stats.teto')}</p>
        <p className="tabular-money text-base font-semibold text-ink">{formatMoney(teto, moeda)}</p>
      </div>
      <div>
        <p className="text-xs text-ink-muted">{t('trips.stats.gasto')}</p>
        <p className="tabular-money text-base font-semibold text-ink">
          {formatMoney(totalGasto, moeda)}
        </p>
      </div>
      <div>
        <p className="text-xs text-ink-muted">{t('trips.stats.sobra')}</p>
        <p className="tabular-money text-base font-semibold text-success">
          {formatMoney(sobra, moeda)}
        </p>
      </div>
    </Card>
  );
}
